import type { CustomFlowbiteTheme } from 'flowbite-react';

export const spinnerTheme: CustomFlowbiteTheme['spinner'] = {
  base: 'inline animate-spin text-titan-folly-600',
  color: {
    failure: 'fill-titan-folly-600',
    gray: 'fill-titan-night-600',
    info: 'fill-titan-blue-600',
    pink: 'fill-titan-folly-600',
    purple: 'fill-titan-folly-600',
    success: 'fill-green-500',
    warning: 'fill-titan-yellow-400',
  },
  light: {
    off: {
      base: 'text-titan-night-300',
      color: {
        failure: '',
        gray: 'fill-titan-night-300',
        info: '',
        pink: '',
        purple: '',
        success: '',
        warning: '',
      },
    },
    on: {
      base: 'text-titan-night-300',
      color: {
        failure: '',
        gray: 'fill-titan-night-300',
        info: '',
        pink: '',
        purple: '',
        success: '',
        warning: '',
      },
    },
  },
  size: {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-10 h-10',
  },
};
